import moment from 'moment'

const formatDate = {}
moment.locale('es')

moment.updateLocale('en', {
    monthsShort : [
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
    ]
});

function format(value, formatString){
    return moment(value).format(formatString)//.toUpperCase()
}

formatDate.install = (Vue) => {
    Vue.filter('format-date', (val, formatString) => {
        return format(val, formatString)
    })
}

export default formatDate